import React from 'react';
import {push, goBack} from 'redux-first-history';
import {useParams, Navigate} from 'react-router-dom';
import {history} from '../../common/store';

export const navigateTo = (path) => {
  return push(path);
};

export const navigateBack = () => {
  return goBack();
};

function redirectNavigation(location) {
  if (location !== window.location.pathname) {
    history.replace(window.location.pathname);
    return true;
  }
  return false;
}

export const withRouter = (Child) => {
  return (props) => {
    const params = useParams();
    if (redirectNavigation(history.location.pathname)) {
      return <Navigate to={history.location.pathname} />;
    }
    return <Child {...props} history={history} params={params} />;
  };
};
